import type { FC } from 'react';
import { Typography } from '@mui/material';

import { StatusPill } from '../../../../atoms/StatusPill';
import { TStatusPillVariant } from '../../../../atoms/StatusPill/types';

import { StyledNameAndStatusContainer, TRUNCATE_TEXT_SX_PROPS } from './styled';

interface IMplDeutschlandTicketNameAndStatusProps {
	firstName: string;
	lastName: string;
	statusText: string;
	statusVariant: TStatusPillVariant;
}

export const MplDeutschlandTicketNameAndStatus: FC<
	IMplDeutschlandTicketNameAndStatusProps
> = ({ firstName, lastName, statusText, statusVariant }) => {
	return (
		<StyledNameAndStatusContainer>
			<Typography
				variant="h4-sb"
				color="primary.main"
				data-testid="dticket-ticket-full-name"
				sx={TRUNCATE_TEXT_SX_PROPS}
			>
				{firstName} {lastName}
			</Typography>
			<StatusPill
				text={statusText}
				variant={statusVariant}
				dataTestId={`dticket-status-pill-${statusText}`}
			/>
		</StyledNameAndStatusContainer>
	);
};
